import { connect } from 'react-redux';
import  SixSenseView from './SixSenseView.jsx'
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'six_sense');
  return {
    'integration': integration,
    integrations: state.legacyRootReducer.settings.integrations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }

  }
}

const SixSensePage = connect(
    mapStateToProps,
    mapDispatchToProps
)(SixSenseView);

export default withUseHooks(SixSensePage);